import * as React from 'react';
import './NoteComponent.css';

import {t} from 'react-multi-lang';
import {INoteProps} from "../../containers/NoteContainer";
import IShortlistable, {shortlistableToString} from "../../interfaces/IShortlistable";
import IShortlistElement from "../../interfaces/IShortlistElement";

class NoteComponent extends React.PureComponent<INoteProps> {
    constructor(props: INoteProps) {
        super(props);

        this.divFromStore = this.divFromStore.bind(this);
        this.removeElement = this.removeElement.bind(this);
    }

    public render() {
        return (
            <>
                <div className="w_header">{t('note.note')}</div>
                <div id="bootstrap_overrides" className="w_vertical">
                    <div className="w_component w_component_fill">{t('note.description')}</div>
                    {this.props.shortlist.length > 0 ?
                        this.divFromStore()
                        :
                        <div className="w_component w_component_fill text-center">
                            <h6>{t('note.empty')}</h6>
                        </div>
                    }
                </div>
            </>
        );
    }

    private divFromStore() {
        const divs: any[] = [];
        const categories: IShortlistElement[][] = [];

        for (const item in IShortlistable) {
            if (!isNaN(Number(item))) {
                categories[item] = [];
            }
        }

        for (const item in IShortlistable) {
            if (!isNaN(Number(item))) {

                for (const shortlistElement of this.props.shortlist) {
                    if (parseInt(shortlistElement.type as any, 10) === parseInt(item, 10)) {
                        categories[item].push(shortlistElement);
                    }
                }
            }
        }

        for (const item in IShortlistable) {
            if (!isNaN(Number(item))) {
                if (categories[item].length !== 0) {
                    divs.push(
                        <div className="w_component" key={item.toString()}>
                            <div className="w_component_row">
                                <b>{shortlistableToString(item)}</b>
                            </div>
                            <div className="w_component_row w_shortlist_elements">
                                {categories[item].map((e: IShortlistElement) =>
                                    <div key={e.value}>
                                        <span className="w_shortlist_element badge badge-success">{e.value}</span>
                                        <span className="w_remove_x badge badge-danger mr-2"
                                              onClick={() => this.removeElement(item, e.value)} title={t('note.hover')}>
                                            x
                                        </span>
                                    </div>)}
                            </div>
                        </div>
                    );
                }
            }
        }

        return divs;
    }

    private removeElement(type: any, value: any) {
        this.props.dispatchShortlistRemove(parseInt(type, 10), value);
    }
}

export default NoteComponent;


// WEBPACK FOOTER //
// ./src/components/NoteComponent/NoteComponent.tsx